import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

const personalPlans = [
  {
    name: 'ライトプラン',
    price: '¥50,000',
    unit: '〜',
    desc: '個人事業主・フリーランスの方向け。小規模なWeb制作や広告サポートに最適です。',
    features: ['小規模Webサイト制作（5ページ以内）', 'LP（ランディングページ）制作', 'SNS広告運用サポート（月1媒体）', 'メール・チャットサポート', '納品後1ヶ月の無償修正対応'],
    color: 'from-pink-50 to-rose-50',
    border: 'border-pink-200',
    badge: 'bg-pink-100 text-pink-600',
    check: 'text-pink-400',
    btn: 'border-pink-300 text-pink-500 hover:bg-pink-50',
  },
  {
    name: 'スタンダードプラン',
    price: '¥120,000',
    unit: '〜',
    desc: '個人事業主の方で、アプリやシステムも検討されている方向けのプランです。',
    features: ['Webサイト制作（10ページ以内）', '簡易アプリ開発（iOS or Android）', 'SNS広告運用（月2媒体）', 'SEO基本対策', 'アクセス解析レポート（月次）', '納品後3ヶ月の保守サポート'],
    color: 'from-rose-50 to-pink-50',
    border: 'border-pink-200',
    badge: 'bg-pink-100 text-pink-600',
    check: 'text-pink-400',
    btn: 'border-pink-300 text-pink-500 hover:bg-pink-50',
  },
];

const businessPlans = [
  {
    name: 'ビジネスプラン',
    price: '¥200,000',
    unit: '〜',
    desc: '中小企業様向けの基本プラン。業務効率化システムや本格的なアプリ開発に対応します。',
    features: ['業務システム開発（カスタム）', '本格的なアプリ制作（iOS & Android）', '広告運用・分析レポート（月次）', '専任担当者によるサポート', '保守・運用サポート（6ヶ月）', 'クラウド環境構築サポート'],
    color: 'from-emerald-50 to-teal-50',
    border: 'border-emerald-200',
    badge: 'bg-emerald-100 text-emerald-700',
    check: 'text-emerald-500',
    btn: 'border-emerald-300 text-emerald-600 hover:bg-emerald-50',
    recommended: true,
  },
  {
    name: 'エンタープライズプラン',
    price: '¥500,000',
    unit: '〜',
    desc: '大規模システム・複数サービスを組み合わせた総合的なDX支援プランです。',
    features: ['大規模業務システム開発', 'マルチプラットフォームアプリ開発', '総合デジタルマーケティング支援', '専任チームによる対応', '保守・運用サポート（12ヶ月）', '月次戦略ミーティング', 'セキュリティ診断・対策'],
    color: 'from-teal-50 to-emerald-50',
    border: 'border-emerald-200',
    badge: 'bg-emerald-100 text-emerald-700',
    check: 'text-emerald-500',
    btn: 'border-emerald-300 text-emerald-600 hover:bg-emerald-50',
  },
];

export default function PlansPage() {
  return (
    <div className="min-h-screen" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
      <Navbar />

      {/* Hero */}
      <section className="relative pt-36 pb-16 bg-gradient-to-b from-pink-50 to-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10 text-center">
          <div className="inline-flex items-center gap-2 mb-4">
            <span className="text-xl">🍑</span>
            <p className="text-xs font-semibold tracking-widest text-pink-400 uppercase">Pricing Plans</p>
          </div>
          <h1 className="text-4xl md:text-6xl font-black text-gray-800 mb-4">料金プラン</h1>
          <p className="text-gray-500 text-sm md:text-base max-w-xl mx-auto">
            中小企業様・個人事業主様それぞれに最適なプランをご用意しています。<br />
            ご予算・ご要望に応じてカスタマイズも可能です。
          </p>
        </div>
      </section>

      {/* Personal Plans */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-8 h-8 flex items-center justify-center bg-pink-100 rounded-full">
              <i className="ri-user-line text-pink-500"></i>
            </div>
            <h2 className="text-2xl md:text-3xl font-black text-gray-800">個人事業主様向けプラン</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {personalPlans.map((plan) => (
              <div key={plan.name} className={`bg-gradient-to-br ${plan.color} border ${plan.border} rounded-2xl p-8`}>
                <span className={`text-xs font-semibold px-3 py-1 rounded-full ${plan.badge} mb-4 inline-block`}>
                  {plan.name}
                </span>
                <p className="text-4xl font-black text-gray-800 mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {plan.price}<span className="text-base font-normal text-gray-500">{plan.unit}</span>
                </p>
                <p className="text-gray-500 text-sm mb-5 leading-relaxed">{plan.desc}</p>
                <ul className="flex flex-col gap-2 mb-7">
                  {plan.features.map((f) => (
                    <li key={f} className="flex items-start gap-2 text-sm text-gray-600">
                      <i className={`ri-check-line ${plan.check} mt-0.5`}></i>
                      {f}
                    </li>
                  ))}
                </ul>
                <Link to="/contact" className={`whitespace-nowrap cursor-pointer inline-flex items-center gap-2 bg-white border ${plan.btn} font-semibold px-6 py-2.5 rounded-full transition-colors text-sm`}>
                  このプランで相談する <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Business Plans */}
      <section className="py-16 bg-gradient-to-b from-emerald-50/40 to-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-8 h-8 flex items-center justify-center bg-emerald-100 rounded-full">
              <i className="ri-building-line text-emerald-600"></i>
            </div>
            <h2 className="text-2xl md:text-3xl font-black text-gray-800">中小企業様向けプラン</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {businessPlans.map((plan) => (
              <div key={plan.name} className={`relative bg-gradient-to-br ${plan.color} border ${plan.border} rounded-2xl p-8`}>
                {plan.recommended && (
                  <div className="absolute -top-3 left-8">
                    <span className="bg-gradient-to-r from-emerald-400 to-teal-500 text-white text-xs font-bold px-4 py-1 rounded-full">おすすめ</span>
                  </div>
                )}
                <span className={`text-xs font-semibold px-3 py-1 rounded-full ${plan.badge} mb-4 inline-block`}>
                  {plan.name}
                </span>
                <p className="text-4xl font-black text-gray-800 mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {plan.price}<span className="text-base font-normal text-gray-500">{plan.unit}</span>
                </p>
                <p className="text-gray-500 text-sm mb-5 leading-relaxed">{plan.desc}</p>
                <ul className="flex flex-col gap-2 mb-7">
                  {plan.features.map((f) => (
                    <li key={f} className="flex items-start gap-2 text-sm text-gray-600">
                      <i className={`ri-check-line ${plan.check} mt-0.5`}></i>
                      {f}
                    </li>
                  ))}
                </ul>
                <Link to="/contact" className={`whitespace-nowrap cursor-pointer inline-flex items-center gap-2 bg-white border ${plan.btn} font-semibold px-6 py-2.5 rounded-full transition-colors text-sm`}>
                  このプランで相談する <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Custom */}
      <section className="py-12 bg-white">
        <div className="max-w-5xl mx-auto px-6 md:px-10">
          <div className="bg-gradient-to-r from-pink-400 via-rose-400 to-emerald-400 rounded-2xl p-10 text-center">
            <h2 className="text-2xl md:text-3xl font-black text-white mb-3">完全カスタムプラン</h2>
            <p className="text-white/80 text-sm mb-7 max-w-xl mx-auto">
              上記プランに当てはまらない場合も、お客様のご要望に応じて柔軟に対応いたします。<br />
              まずはお気軽にご相談ください。
            </p>
            <Link to="/contact" className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 bg-white text-gray-800 font-semibold px-8 py-3.5 rounded-full hover:bg-gray-50 transition-colors text-sm">
              <i className="ri-mail-line"></i>
              お問い合わせ・ご相談
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
